export default class CompetingFirm {
  id?: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
  }

  public static of(obj: any): CompetingFirm {
    return new CompetingFirm(obj || {});
  }

  public static ofList(obj: any[]): CompetingFirm[] {
    return obj.map(this.of);
  }
}
